import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import JWTService from 'services/JWT';
import useAuth from 'providers/Auth/useAuth';

const SSOCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const init = async () => {
      const params = new URLSearchParams(window.location.search);

      if (params.has('error')) {
        const error = params.get('error');
        const email = params.get('email');

        if (error === 'user_not_found') {
          toast.error(t('errors.ERR_SSO_USER_NOT_FOUND', { email }));
        } else {
          toast.error(t('errors.ERR_SSO_FAILED'));
        }

        window.history.replaceState({}, '', '/auth/callback');
        navigate('/login');
        return;
      }

      const token = params.get('token');
      const refreshToken = params.get('refresh_token');
      const dataParam = params.get('data');

      if (!token || !dataParam) {
        navigate('/login');
        return;
      }

      await JWTService.setSession(token, refreshToken);

      const user = JSON.parse(decodeURIComponent(dataParam));
      localStorage.setItem('cooperative', user.cooperative?.id);
      setUser(user);

      window.history.replaceState({}, '', '/auth/callback');
      navigate('/');
    };
    init();
  }, [navigate, setUser]);

  return null;
};

export default SSOCallback;
